import classNames from "classnames";
import React, { ReactNode } from "react";
import "./selectgrid.scss";

export interface SelectGridItem {
    id: string;
    label?: string;
    Node: ReactNode;
}

interface SelectGridProps {
    items: SelectGridItem[];
    selectedId?: string;
    onSelect: (id: string) => void;
}

const SelectGrid: React.FC<SelectGridProps> = ({ items, selectedId, onSelect }) => {
    return (
        <div className="select-grid">
            {items.map(item => (
                <div
                    key={item.id}
                    className={classNames("select-grid-item", {
                        selected: selectedId === item.id,
                    })}
                    onClick={() => onSelect(item.id)}
                >
                    {item.Node}
                    {item.label && <p className="select-grid-label">{item.label}</p>}
                </div>
            ))}
        </div>
    );
};

export default SelectGrid;